
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ScheduleHeader() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/8e563ca5-c856-4df8-ac33-ff016d92cfb7.png"
            alt="日本音楽会場協会 東京クラブ"
            className="h-12 w-auto"
          />
          <div className="text-gray-900">
            <div className="text-sm font-medium">日本音楽会場協会</div>
            <div className="text-xs">東京クラブ</div>
          </div>
        </Link>
        <div className="flex items-center gap-8">
          <Link to="/" className="text-sm font-medium text-gray-700 hover:opacity-70 transition-colors cursor-pointer whitespace-nowrap">
            トップページ
          </Link>
          <a href="/#venues" className="text-sm font-medium text-gray-700 hover:opacity-70 transition-colors cursor-pointer whitespace-nowrap">
            参加会場
          </a>
          <a href="/#artists" className="text-sm font-medium text-gray-700 hover:opacity-70 transition-colors cursor-pointer whitespace-nowrap">
            登録アーティスト
          </a>
          <Link to="/schedule" className="text-sm font-medium text-gray-900 hover:opacity-70 transition-colors cursor-pointer whitespace-nowrap">
            公演スケジュール
          </Link>
          <a href="/#contact" className="text-sm font-medium text-gray-700 hover:opacity-70 transition-colors cursor-pointer whitespace-nowrap">
            お問い合わせ
          </a>
        </div>
      </div>
    </nav>
  );
}
